/* eslint-disable @typescript-eslint/no-namespace */
import { DealVersion, Departement } from '../../types/deal.types';
import { MapperHelpers } from '../mappers';

export namespace DealsFinancialAdvisors {
  export function getFinancialAdvisorNames(deals: DealVersion[]) {
    return MapperHelpers.getUniqSortedItemPropertiesFromArray(deals, {
      getProperty: (deal: DealVersion) => deal.financialAdvisors || [],
      getArrayProperty: (advisors: Departement[]) =>
        advisors.map((advisor: Departement) => advisor.name),
      uniqBy: (name: string) => name,
      sortBy: (name: string) => name,
    });
  }
}
